import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { useTracking } from "react-tracking";
import { apiGetAvailableFlavors, apiGetPrices, } from "Root/api/apiProfile";
import { setAddonFlavor, setFlavorAmount, setAddonQuantity, setQuantity, setAddonAttribute, setAttribute, } from "Root/profile/redux/actionCreators/makeActionCreator";
import { updateItemsThunk, AddUserCartItemThunk, DeleteUserCartItemThunk, addNotRecommendedItem, LoadUserCartThunk, } from "Root/profile/redux/thunkCreators/products/userCart";
import toastService from "Root/profile/toastService";
import utils from "Root/profile/utils";
import { EditProduct } from "Root/profile/utils/trackingEnums";
import { useScreenWidth } from "../hooks";
import { updateAttributeHelper, validateProductAttributes } from "../utils";
import posthog from "posthog-js";
import { cvgTrack } from "reactjs/src/utils/tracking";
// TODO: fetch from backend
const PRICES = {
    protein: {},
    hydration: {},
    preworkout: {},
    fiber: {},
    creatine: {},
    collagen: {},
};
const useProductDetailsDrawer = (onSubmit, openDrawer, attributes, bags_info, scrollToFlavorSelect, isMoreDetails, isMissingItem, net_price, quantity, item_type, product, flavors, toggleDrawer, sku, source) => {
    const isMobile = useScreenWidth() < 968;
    const [allFlavors, setAllFlavors] = useState([]);
    const [maxFlavors, setMaxFlavors] = useState(0);
    const { plan } = useSelector((state) => state.ordersInfo.nextOrderDates);
    const [isOpen, setIsOpen] = useState(true);
    const [isOpenNutritionFacts, setIsOpenNutritionFacts] = useState(false);
    const [allProductPrices, setAllProductPrices] = useState(PRICES);
    const [localQuantity, setLocalQuantity] = useState(1);
    const missingAddons = useSelector((state) => state.missingAddons);
    const history = useHistory();
    const dispatch = useDispatch();
    const currentReduxProteinQuantity = useSelector((state) => state.userCart.find((p) => p.item_type === "protein")
        ?.currentReduxQuantity);
    const reduxProteinSelectedFlavCount = useSelector((state) => state.userCart
        .find((p) => p.item_type === "protein")
        ?.bags_info[0].selected_flavors.filter((allFlavorObj) => allFlavorObj.count > 0)
        .map((flavorObj) => flavorObj.count)
        .reduce((sum, current) => sum + current, 0));
    const [disabledButton, setDisabledButton] = useState(false);
    const hasSubscription = useSelector((state) => state.user.has_subscription);
    const isByb = useSelector((state) => state.user.user_class === "byb");
    const toggleNutritionDrawer = (value) => () => {
        setIsOpenNutritionFacts(value);
    };
    const getItNow = (queryString) => {
        if (queryString) {
            history.push(`/app/get-it-now#flavorboost${queryString}`);
        }
        else {
            dispatch(LoadUserCartThunk());
            history.push(`/app/get-it-now#${item_type}`);
        }
    };
    const isFBInUserCart = useSelector((state) => state.userCart.filter((item) => item.item_type === "additional_flavorboost").length > 0);
    const { trackEvent } = useTracking();
    const trackQuantityChange = (qty) => {
        trackEvent({
            funComponent: EditProduct.Edit_servings,
            event: `${EditProduct.Edit_servings}__product_name=${product}__servings_change=${qty}`,
        });
    };
    const trackFlavorsChange = () => {
        trackEvent({
            funComponent: EditProduct.edit_product,
            event: `${EditProduct.Edit_flavors}__product_name=${product}`,
        });
    };
    const trackAttributeChange = (attr) => {
        trackEvent({
            funComponent: EditProduct.edit_product,
            event: `${EditProduct.Edit_customizations}__product_name=${product}__customization_changed=${attr}`,
        });
    };
    const trackDeleteItem = () => {
        trackEvent({
            funComponent: EditProduct.edit_product,
            event: `${EditProduct.Delete_product}__product_name=${product}`,
        });
    };
    const trackAddItem = (productKey) => {
        trackEvent({
            funComponent: EditProduct.edit_product,
            event: `${EditProduct.Add_product}__product_name=${productKey}`,
        });
    };
    const getPrice = () => {
        if (product && !utils.isFlavorBoost(product)) {
            return `$${allProductPrices[product] &&
                allProductPrices[product][Number(quantity || 1)]
                ? allProductPrices[product][Number(quantity) || 1].toFixed(2)
                : 0.0}`;
        }
        else if (net_price) {
            if (utils.isFlavorBoost(product)) {
                const priceint = Math.max(parseFloat(net_price.replace("$", "")) * flavors.length, 3);
                return `$${priceint.toFixed(2)}`;
            }
            const priceint = parseFloat(net_price.replace("$", ""));
            return `$${priceint.toFixed(2)}`;
        }
        return "";
    };
    const [additionalFlavorBoosts, setAdditionalFlavorBoosts] = useState([]);
    const [selectedProteinFlavors, setSelectedProteinFlavors] = useState([]);
    const reduxUserCart = useSelector((state) => state.userCart);
    async function getProteinFlavors() {
        const data = await apiGetAvailableFlavors("protein");
        setAllFlavors(data.flavors);
        const selectedFlavors = additionalFlavorBoosts;
        const selectedProtFlavors = data.flavors.map((item) => {
            const selectedItem = selectedFlavors.find((f) => f.short_name === item.short_name);
            if (selectedItem) {
                return {
                    ...selectedItem,
                    count: 0,
                };
            }
            return {
                short_name: item.short_name,
                count: 0,
            };
        });
        setSelectedProteinFlavors(selectedProtFlavors);
    }
    const fetchPrices = async () => {
        const data = await apiGetPrices();
        setAllProductPrices(data);
    };
    useEffect(() => {
        if (openDrawer && Object.keys(allProductPrices.protein).length === 0) {
            fetchPrices();
        }
    }, [openDrawer]);
    const getItNowFb = () => {
        const query = selectedProteinFlavors
            .filter((item) => item.count)
            .map((item) => `${item.short_name}=${item.count}`)
            .join("&");
        getItNow(`?${query}`);
    };
    const onChangeProteinFlavor = (value, name) => {
        const newFlavors = selectedProteinFlavors.map((item) => {
            if (item.short_name === name) {
                return {
                    ...item,
                    count: value,
                };
            }
            return item;
        });
        trackFlavorsChange();
        setSelectedProteinFlavors(newFlavors);
    };
    const getAdditionalFlavorBoosts = () => {
        // function to extract just the additional flavor boosts from user Cart
        const simpleFlavors = reduxUserCart
            .filter((item) => item.item_type === "additional_flavorboost")
            .map((item) => ({
            short_name: item.sku.replace("additional_", ""),
            count: item.quantity,
        }));
        setAdditionalFlavorBoosts(simpleFlavors);
    };
    useEffect(() => {
        getAdditionalFlavorBoosts();
    }, [reduxUserCart]);
    const setFlavorsAmount = (value, product_name, bagId, isProtein) => {
        if (isMissingItem) {
            dispatch(setAddonFlavor({ value, name: product_name, bagId }));
        }
        else {
            trackFlavorsChange();
            dispatch(setFlavorAmount({ value, name: product_name, bagId, isProtein }));
        }
    };
    const notRecommendedItem = isByb &&
        !reduxUserCart.find((item) => item.item_type === product) &&
        !missingAddons.find((item) => item.product_key === product);
    const onChangeAmount = (value) => {
        if (notRecommendedItem) {
            setLocalQuantity(Number(value));
            return;
        }
        if (isMissingItem) {
            dispatch(setAddonQuantity({ value, name: product }));
        }
        else {
            const prevQty = reduxUserCart.find((item) => item.short_name === product)?.quantity;
            const trackText = prevQty && Number(prevQty) > Number(value) ? "decrease" : "increase";
            trackQuantityChange(trackText);
            dispatch(setQuantity({ value, name: sku }));
        }
    };
    const getBagsOptions = () => {
        if (product &&
            !utils.isAdditionalItem(product) &&
            product !== "target_hydration") {
            return plan === "advantage"
                ? JSON.parse(JSON.stringify(utils.bagAdvantageOptions[product]))
                : JSON.parse(JSON.stringify(utils.bagOptionsV2[product]));
        }
        return [];
    };
    const getMaxQuantityForFlavors = () => {
        if ("protein".includes(product)) {
            return Number(quantity) * 2;
        }
        if ("hydration".includes(product) || "preworkout".includes(product)) {
            return Number(quantity) !== 0 ? 1 : 0;
        }
        return 1;
    };
    useEffect(() => {
        if (product) {
            setMaxFlavors(getMaxQuantityForFlavors());
        }
    }, [product, quantity]);
    const validateFlavors = () => {
        if ([
            "hydration",
            "preworkout",
            "greens",
            isMissingItem ? "protein" : "",
        ].includes(product)) {
            const validated = bags_info &&
                bags_info.length &&
                bags_info?.filter((bag) => bag.selected_flavors.filter((b) => b.count > 0).length > 0);
            if (validated && bags_info) {
                if (isMissingItem && product === "protein") {
                    const proteinFlavors = validated
                        .map((item) => item.selected_flavors.reduce((prev, curr) => prev + curr.count, 0))
                        .reduce((prev, curr) => prev + curr, 0);
                    return proteinFlavors === quantity * 2;
                }
                return validated?.length > bags_info.length - 1;
            }
            return false;
        }
        if (utils.isFlavorBoost(product)) {
            return selectedProteinFlavors.filter((item) => item.count).length > 0;
        }
        return true;
    };
    const updateItemsProperties = async () => {
        if (!validateFlavors()) {
            scrollToFlavorSelect();
            return;
        }
        onSubmit && onSubmit();
        await dispatch(updateItemsThunk());
    };
    const onAddItem = async () => {
        if (!validateFlavors()) {
            scrollToFlavorSelect();
            return;
        }
        onSubmit && onSubmit();
        trackAddItem(product);
        const eventProperties = {
            product_id: sku,
            name: product,
            price: Number(getPrice().replace("$", "")),
            currency: "USD",
            quantity: localQuantity,
        };
        cvgTrack({
            eventName: "Added To Cart",
            properties: eventProperties,
        });
        if (isByb !== undefined && source) {
            const eventName = isByb ? "add_to_cart" : "add_to_subscription";
            posthog.capture(eventName, {
                source,
            });
        }
        if (notRecommendedItem) {
            await dispatch(addNotRecommendedItem({
                item: product,
                quantity: localQuantity,
                attributes: {},
                flavors: [],
            }));
            return;
        }
        if (utils.isFlavorBoost(product)) {
            await dispatch(AddUserCartItemThunk(product, selectedProteinFlavors));
        }
        else {
            await dispatch(AddUserCartItemThunk(product));
        }
    };
    const onToggleChange = (value, attr_name, bagId, addonAttribute) => {
        const copyAttributes = updateAttributeHelper(addonAttribute, value, attr_name);
        const isValid = validateProductAttributes(copyAttributes, product);
        if (isValid) {
            if (isMissingItem) {
                dispatch(setAddonAttribute({ value, name: attr_name, bagId }));
            }
            else {
                const attrString = value ? `add_${attr_name}` : `remove_${attr_name}`;
                trackAttributeChange(attrString);
                dispatch(setAttribute({ value, name: attr_name, bagId }));
            }
        }
    };
    const onItemDelete = async (itemKey) => {
        toggleDrawer(false)();
        trackDeleteItem();
        await dispatch(DeleteUserCartItemThunk({ item_key: itemKey, next_order_only: false }));
    };
    useEffect(() => {
        if (allFlavors.length === 0 &&
            (utils.isFlavorBoost(product) || product === "protein")) {
            getProteinFlavors();
        }
    }, [product]);
    const getButtonLabel = () => {
        if (!utils.getIsBooster(product) && !utils.isAdditionalItem(product)) {
            if (!disabledButton && validateFlavors()) {
                return isMissingItem ? "Add To Subscription" : "Save Changes";
            }
            return "Select Flavors";
        }
        return isMissingItem ? "Add To Subscription" : "Save Changes";
    };
    useEffect(() => {
        if (quantity &&
            item_type === "protein" &&
            currentReduxProteinQuantity !== undefined) {
            const remainingCount = (quantity - currentReduxProteinQuantity) * 2;
            if (quantity > currentReduxProteinQuantity) {
                setDisabledButton(true);
                toastService.errorMessage(`Please add ${Math.abs(remainingCount)} additional flavor boosts to save`);
            }
            else if (quantity < currentReduxProteinQuantity) {
                setDisabledButton(true);
                toastService.errorMessage(remainingCount > 0
                    ? `Please add ${Math.abs(remainingCount)} additional flavor boosts to save`
                    : `Please remove ${Math.abs(remainingCount)} flavor boosts to save`);
            }
        }
    }, [quantity]);
    useEffect(() => {
        if (quantity && item_type === "protein" && currentReduxProteinQuantity) {
            if (reduxProteinSelectedFlavCount === 0 ||
                quantity * 2 === reduxProteinSelectedFlavCount) {
                setDisabledButton(false);
            }
            else {
                setDisabledButton(true);
            }
        }
    }, [quantity, reduxProteinSelectedFlavCount]);
    return {
        disabledButton,
        getButtonLabel,
        onItemDelete,
        onToggleChange,
        onAddItem,
        updateItemsProperties,
        onChangeAmount,
        getBagsOptions,
        setFlavorAmount,
        setFlavorsAmount,
        getPrice,
        isMobile,
        maxFlavors,
        isOpen,
        setIsOpen,
        allFlavors,
        getProteinFlavors,
        selectedProteinFlavors,
        onChangeProteinFlavor,
        isFBInUserCart,
        plan,
        validateFlavors,
        getItNow,
        getItNowFb,
        setIsOpenNutritionFacts,
        isOpenNutritionFacts,
        toggleNutritionDrawer,
        hasSubscription,
        localQuantity,
        notRecommendedItem,
    };
};
export default useProductDetailsDrawer;
